'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

// COMPONENTES DEL LAB

// import ComLabRRSS from 'com-lab-rrss';
// import 'com-lab-rrss/build/comLabRRSS.css';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Cover = require('./Cover.scss');

var _Cover2 = _interopRequireDefault(_Cover);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _metadata = require('../../../metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _scroll = require('redux/modules/scroll');

var scrollActions = _interopRequireWildcard(_scroll);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cover = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    positionScroll: state.scroll.positionScroll
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, scrollActions), dispatch);
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Cover, _React$Component);

  function Cover(props) {
    (0, _classCallCheck3.default)(this, Cover);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Cover.__proto__ || (0, _getPrototypeOf2.default)(Cover)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Cover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          Cover = _props.strings.Cover,
          isMobile = _props.isMobile;


      var rrss = !this.props.isMobile ? _react2.default.createElement(_components.ComLabRRSS, { metadata: _metadata2.default, isMobile: isMobile, expanded: true, vertical: true }) : _react2.default.createElement(_components.ComLabRRSS, { isMobile: isMobile, metadata: _metadata2.default, expanded: true, horizontal: true });
      var classRRSS = (0, _classnames2.default)({
        'cover__rrss': true,
        'cover__rrss--dark': this.props.positionScroll == 2 && !this.props.isMobile
      });

      var soundMutedHtml = null;
      // if(!this.props.isMobile){
      //   soundMutedHtml = ( <SoundMuted /> );
      // }

      return _react2.default.createElement(
        'div',
        { className: 'cover' },
        _react2.default.createElement(
          'div',
          { className: 'cover__container' },
          _react2.default.createElement(
            'div',
            { className: 'cover__container__header' },
            _react2.default.createElement(
              'a',
              { href: 'http://www.rtve.es/noticias/exhumacion-franco/', target: '_blank', className: 'cover__container__header__btn' },
              'LA EXHUMACI\xD3N, EN RTVE.es '
            )
          ),
          _react2.default.createElement('h1', { className: 'cover__container__title', dangerouslySetInnerHTML: { __html: Cover.title } }),
          _react2.default.createElement(
            'p',
            { className: 'cover__container__text' },
            isMobile ? Cover.textMobile : Cover.text
          ),
          _react2.default.createElement('button', { className: 'cover__container__button cover__container__button--cover icon-arrow', onClick: function onClick() {
              _this2.props.isMobile && !_this2.props.isTablet ? _this2.props.setPositionScroll(2) : _this2.props.setPositionScroll(1);
              _this2.props.setCarouselScroll(2);
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: classRRSS },
          soundMutedHtml,
          rrss
        ),
        _react2.default.createElement('div', { className: 'cover__bg__left' }),
        _react2.default.createElement('div', { className: 'cover__bg__right' })
      );
    }
  }]);
  return Cover;
}(_react2.default.Component)) || _class);
exports.default = Cover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Cover/Cover.jsx
// module id = 700
// module chunks = 0